export default function normalizeName (name) {
	return String(name || '').toLowerCase().replace(/\//g, '_');
}



// WEBPACK FOOTER //
// ./node_modules/moment-timezone/src/database/normalize-name.js